module.exports = __webpack_public_path__ + "img/icon5.b3024c4c.png";